import { env } from "@/lib/utils";

// Shared across every `LocationPickerModal` mount (the admin can open/close
// "Pick a location" many times per session) — a second call while the
// script is already loaded/loading returns the same promise instead of
// injecting a duplicate <script> tag.
let loadPromise: Promise<void> | null = null;

export const loadGoogleMaps = (): Promise<void> => {
  if (typeof google !== "undefined" && google.maps) return Promise.resolve();
  if (loadPromise) return loadPromise;

  loadPromise = new Promise((resolve, reject) => {
    const script = document.createElement("script");
    // `libraries=places` — needed for `google.maps.places.PlaceAutocompleteElement`
    // (the search box in LocationPickerModal.tsx) to be available on the
    // same global `google.maps` object, without a separate
    // `importLibrary("places")` call.
    script.src = `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(env("VITE_GOOGLE_MAPS_API_KEY"))}&libraries=places`;
    script.async = true;
    script.defer = true;
    script.onload = () => resolve();
    script.onerror = () => {
      // Allow a retry on the next open rather than caching a permanent
      // failure (e.g. a transient network error).
      loadPromise = null;
      reject(new Error("Failed to load Google Maps"));
    };
    document.head.appendChild(script);
  });

  return loadPromise;
};
